const baseSteps = [
  { label: 'Decyzja', name: 'TODO', required: true },
  { label: 'Zdjęcia uszkodzeń', name: 'TODO', required: true },
  { label: 'Kosztorys', name: 'TODO', required: false },
  { label: 'Zgłoszenie szkody', name: 'TODO', required: false },
  { label: 'Protokół szkody', name: 'TODO', required: false },
];

const variants: Record<
  'default' | 'withInvoices' | 'withPolicy' | 'withBoth',
  { label: string; name: string; required: boolean }[]
> = {
  default: [],
  withInvoices: [{ label: 'Faktury, rachunki', name: 'TODO', required: true }],
  withPolicy: [{ label: 'Polisa', name: 'TODO', required: true }],
  withBoth: [
    { label: 'Polisa', name: 'TODO', required: true },
    { label: 'Faktury, rachunki', name: 'TODO', required: true },
  ],
};

const createSteps = (
  variant: 'default' | 'withInvoices' | 'withPolicy' | 'withBoth' = 'default'
) =>
  variant === 'withInvoices'
    ? [
        ...baseSteps.slice(0, 1),
        ...baseSteps.slice(1, 2),
        ...(variants[variant] || []).slice(0, 1),
        ...(variants[variant] || []).slice(1, 2),
        ...baseSteps.slice(2),
      ]
    : [
        ...baseSteps.slice(0, 1),
        ...(variants[variant] || []).slice(0, 1),
        ...baseSteps.slice(1, 2),
        ...(variants[variant] || []).slice(1, 2),
        ...baseSteps.slice(2),
      ];

const addDryingReport = (
  steps: { label: string; name: string; required: boolean }[]
) => [
  ...steps,
  { label: 'Zgłoszenie osuszania', name: 'TODO', required: false },
];

export const hhDocumentsSteps = createSteps();
export const hhDocumentsStepsWithInvoices = createSteps('withInvoices');
export const hhDocumentsStepsWithPolicy = createSteps('withPolicy');
export const hhDocumentsStepsWithBoth = createSteps('withBoth');

export const hhDocumentsStepsWithDryingReport =
  addDryingReport(hhDocumentsSteps);

export const hhDocumentsStepsWithInvoicesAndDryingReport = addDryingReport(
  hhDocumentsStepsWithInvoices
);

export const hhDocumentsStepsWithPolicyAndDryingReport = addDryingReport(
  hhDocumentsStepsWithPolicy
);

export const hhDocumentsStepsWithBothAndDryingReport = addDryingReport(
  hhDocumentsStepsWithBoth
);
